<template>
    <div class="analysis">
        <div class="header">
            <div class="title">数据中心</div>
            <!-- <div class="button">实训任务</div> -->
        </div>
        <div class="container">
            <div class="home-container">
                <div class="container-content">
                    <!-- 顶部状态栏 -->
                    <div class="container-content_header" v-if="$route.meta.isHeader">
                        <i class="el-icon-arrow-left" v-if="$route.meta.prev" @click="$router.back()"></i>

                        {{ $route.meta.headerLabel }}
                    </div>

                    <!-- 内容区 -->
                    <el-scrollbar
                        :class="[
                            'container-content_box',
                            {
                                'is-header': $route.meta.isHeader,
                                'is-footer': $route.meta.isFooter,
                                'is-pay': $route.name === 'DouHotVideoData',
                            },
                        ]"
                    >
                        <router-view
                            ref="routerRef"
                            @pay-change="handlePayMoneyChange"
                            @time-change="handleTimeChange"
                            @address-change="handleAddressChange"
                            @interest-change="handleInterestChange"
                            @coupon-change="handleCouponChange"
                            @money-change="handleMoneyChange"
                            @want-show="handleWantShow"
                            @show-info="handleShowInfo"
                        ></router-view>
                    </el-scrollbar>

                    <!-- 付款 -->
                    <div class="container-content_pay-footer" v-if="$route.name === 'DouHotVideoData'">
                        <div class="pay-money">￥{{ payMoney }}</div>

                        <div class="pay-button" @click="handlePay">支付</div>
                    </div>

                    <!-- 底部菜单栏 -->
                    <div class="container-content_footer" v-if="$route.meta.isFooter">
                        <div
                            :class="['menu-item', { 'is-check': currentIndex === item.index }]"
                            v-for="item in menuOption"
                            :key="item.index"
                            @click="handleCheckMenu($event, item)"
                        >
                            <i class="iconfont check-menu">
                                {{ item.index === currentIndex ? formatIconfont(item.checkIcon) : formatIconfont(item.defaultIcon) }}
                            </i>

                            <span class="check-menu">{{ item.label }}</span>
                        </div>
                    </div>

                    <TimeChangeDrawer
                        :show="timeDrawer.visible"
                        :time="timeDrawer.time"
                        @close="timeDrawer.visible = false"
                        @confirm="handleConfirmTime"
                    ></TimeChangeDrawer>

                    <ProvinceDrawer
                        :show="provinceDrawer.visible"
                        :checkList="provinceDrawer.check"
                        @close="provinceDrawer.visible = false"
                        @confirm="handleConfirmProvince"
                    ></ProvinceDrawer>

                    <CountyDrawer
                        :show="countyDrawer.visible"
                        :checkList="countyDrawer.check"
                        @close="countyDrawer.visible = false"
                        @confirm="handleConfirmCounty"
                    ></CountyDrawer>

                    <InterestDrawer
                        :show="interestDrawer.visible"
                        :checkList="interestDrawer.check"
                        @close="interestDrawer.visible = false"
                        @confirm="handleConfirmInterest"
                    ></InterestDrawer>

                    <CouponDrawer
                        :show="couponDrawer.visible"
                        @close="couponDrawer.visible = false"
                        @confirm="couponDrawer.visible = false"
                    ></CouponDrawer>

                    <InformationDialog
                        :show="informationDialog.visible"
                        :message="informationDialog.message"
                        :title="informationDialog.title"
                        :type="informationDialog.type"
                        @close="informationDialog.visible = false"
                        @confirm="handleConfirmInfo"
                    ></InformationDialog>

                    <MessageTip :show="messageTip.visible" @close="messageTip.visible = false"></MessageTip>

                    <CustomMoneyDialog
                        :show="customMoneyDialog.visible"
                        :value="customMoneyDialog.money"
                        @close="customMoneyDialog.visible = false"
                        @confirm="handleConfirmCustomMoney"
                    ></CustomMoneyDialog>

                    <WantCarousel :show="wantCarousel.visible" @close="wantCarousel.visible = false"></WantCarousel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CountyDrawer from "../../../components/training/dou/CountyDrawer.vue";
import InformationDialog from "../../../components/training/dou/InformationDialog.vue";
import ProvinceDrawer from "../../../components/training/dou/ProvinceDrawer.vue";
import TimeChangeDrawer from "../../../components/training/dou/TimeChangeDrawer.vue";
import InterestDrawer from "../../../components/training/dou/InterestDrawer.vue";
import CouponDrawer from "../../../components/training/dou/CouponDrawer.vue";
import MessageTip from "../../../components/training/dou/MessageTip.vue";
import CustomMoneyDialog from "../../../components/training/dou/CustomMoneyDialog.vue";
import WantCarousel from "../../../components/training/dou/WantCarousel.vue";

export default {
    name: "DouIndex",
    data() {
        return {
            currentIndex: 1,
            menuOption: [
                {
                    label: "上热门",
                    defaultIcon: "&#xe61a;",
                    checkIcon: "&#xe64b;",
                    index: 1,
                    routePath: "/training/dou/hot",
                    name: "DouHotVideoData",
                },
                {
                    label: "投放管理",
                    defaultIcon: "&#xe852;",
                    checkIcon: "&#xe692;",
                    index: 2,
                    routePath: "/training/dou/delivery",
                    name: "DouDeliveryManagement",
                },
                {
                    label: "我的DOU+",
                    defaultIcon: "&#xe602;",
                    checkIcon: "&#xe606;",
                    index: 3,
                    routePath: "/training/dou/myData",
                    name: "DouMyData",
                },
            ],
            payMoney: 0,
            timeDrawer: {
                visible: false,
                time: "",
            },
            provinceDrawer: {
                visible: false,
                check: [],
            },
            countyDrawer: {
                visible: false,
                check: [],
            },
            informationDialog: {
                visible: false,
                title: "",
                message: "",
                type: undefined,
            },
            interestDrawer: {
                visible: false,
                check: [],
            },
            couponDrawer: {
                visible: false,
            },
            messageTip: {
                visible: false,
            },
            customMoneyDialog: {
                visible: false,
                money: undefined,
            },
            wantCarousel: {
                visible: false,
            },
        };
    },
    created() {
        this.getCurrentIndex();
    },
    computed: {},
    components: {
        TimeChangeDrawer,
        ProvinceDrawer,
        InformationDialog,
        CountyDrawer,
        InterestDrawer,
        CouponDrawer,
        MessageTip,
        CustomMoneyDialog,
        WantCarousel,
    },
    watch: {
        $route() {
            const warp = document.querySelector(".container-content_box .el-scrollbar__wrap");

            if (warp) {
                warp.scrollTo({ top: 0 });
            }
        },
    },
    methods: {
        // 设置currentIndex。刷新后重置
        getCurrentIndex() {
            const currentMenuItem = this.menuOption.find((menu) => menu.name === this.$route.name);

            if (currentMenuItem) {
                this.currentIndex = currentMenuItem.index;
            }
        },

        // 将iconfont字符串转化为unicode
        formatIconfont(icon) {
            const reg = new RegExp(/(&#x)?(.*)/);
            let iconfontName = "";
            if (reg.test(icon)) {
                iconfontName = reg.exec(icon)[2];
            }

            return String.fromCharCode(parseInt(iconfontName, 16));
        },

        // 切换底部菜单
        handleCheckMenu(event, item) {
            if (event.target && event.target.className.includes("check-menu")) {
                this.currentIndex = item.index;

                this.gotoRouterPage(item);
            }
        },

        // 根据index前往对应页面
        gotoRouterPage(menuItem) {
            if (!menuItem.routePath) return;

            this.$router.push({
                path: menuItem.routePath,
                query: {
                    data_type: this.$route.query.data_type,
                },
            });
        },

        // 付款金额发生变化
        handlePayMoneyChange(val) {
            this.payMoney = val;
        },

        // 自定义推广-选择投放时间
        handleTimeChange(time) {
            this.timeDrawer.time = time;

            this.timeDrawer.visible = true;
        },

        // 自定义推广-确认时间
        handleConfirmTime(time) {
            if (this.$refs.routerRef && this.$refs.routerRef.handleConfirmTime) {
                this.$refs.routerRef.handleConfirmTime(time);
            }
        },

        // 自定义推广-选择地址
        handleAddressChange(item, checkList) {
            if (item === 1) {
                // 省市
                this.provinceDrawer.check = checkList;
                this.provinceDrawer.visible = true;
            } else {
                // 区县
                this.countyDrawer.check = checkList;
                this.countyDrawer.visible = true;
            }
        },

        // 自定义推广-确认省市
        handleConfirmProvince(provinces) {
            if (this.$refs.routerRef && this.$refs.routerRef.handleConfirmAddress) {
                this.$refs.routerRef.handleConfirmAddress(1, provinces);
            }
        },

        // 自定义推广-确认城市
        handleConfirmCounty(counties) {
            if (this.$refs.routerRef && this.$refs.routerRef.handleConfirmAddress) {
                this.$refs.routerRef.handleConfirmAddress(2, counties);
            }
        },

        // dialog弹框显示
        handleShowInfo(title, message, type) {
            this.informationDialog.title = title;
            this.informationDialog.message = message;
            this.informationDialog.type = type;

            this.informationDialog.visible = true;
        },

        // 信息弹框确认事件
        handleConfirmInfo(type) {
            if (type === 2) {
                // 地域选择-省市按钮
                const checkList = this.$refs.routerRef.customerPromotion.cityDetail;
                this.handleAddressChange(1, checkList);
            } else if (type === 3) {
                // 地域选择-区县按钮
                const checkList = this.$refs.routerRef.customerPromotion.countyDetail;
                this.handleAddressChange(2, checkList);
            } else if (type === 4) {
                // 支付
                this.messageTip.visible = true;
            }
        },

        // 自定义推广-打开更多兴趣标签
        handleInterestChange(checkList) {
            this.interestDrawer.check = checkList;

            this.interestDrawer.visible = true;
        },

        // 自定义推广-确认兴趣标签
        handleConfirmInterest(tags) {
            if (this.$refs.routerRef && this.$refs.routerRef.handleConfirmInterest) {
                this.$refs.routerRef.handleConfirmInterest(tags);
            }
        },

        // 优惠券选择
        handleCouponChange() {
            this.couponDrawer.visible = true;
        },

        // 支付
        handlePay() {
            this.informationDialog.title = "";
            this.informationDialog.message = "是否确定支付?";
            this.informationDialog.type = 4;

            this.informationDialog.visible = true;
        },

        // 自定义金额
        handleMoneyChange(money) {
            this.customMoneyDialog.money = money;
            this.customMoneyDialog.visible = true;
        },

        // 自定义金额确认
        handleConfirmCustomMoney(money) {
            if (this.$refs.routerRef && this.$refs.routerRef.handleConfirmMoney) {
                this.$refs.routerRef.handleConfirmMoney(money);
            }
        },

        // 我想要轮播图
        handleWantShow() {
            this.wantCarousel.visible = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.analysis {
    --footer-height: 55px;
    --header-height: 50px;
    --footer-pay-height: 50px;

    width: 100%;
    min-height: 100vh;
    background: #fff;
    .header {
        width: 100%;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 30px;
        box-sizing: border-box;
        border-bottom: 1px solid #eeeeee;
        .title {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #666666;
            line-height: 19px;
            text-align: left;
            font-style: normal;
            text-transform: none;
        }
        .button {
            width: 88px;
            height: 36px;
            background: #006eff;
            border-radius: 4px 4px 4px 4px;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    .container {
        width: 100%;
        display: flex;
        justify-content: center;
        padding-top: 50px;
        box-sizing: border-box;

        .home-container {
            position: relative;
            width: 420px;
            height: 740px;
            background-image: url("../../../assets/img/image/phone-dc9743aa.png");
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            display: flex;
            justify-content: center;
            align-items: center;

            .container-content {
                width: 340px;
                height: 640px;
                background-color: #f8f8f8;
                position: relative;

                &_header {
                    height: var(--header-height);
                    background-color: #ffffff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    // font-family: PingFang-SC;
                    font-weight: 600;
                    font-size: 16px;
                    color: #333;
                    position: relative;

                    .el-icon-arrow-left {
                        position: absolute;
                        left: 12px;
                        font-size: 20px;
                        color: #333;
                        font-weight: 600;
                        cursor: pointer;
                    }
                }

                &_box {
                    // height: calc(100% - var(--footer-height));

                    &.is-header {
                        height: calc(100% - var(--header-height));
                    }

                    &.is-pay {
                        height: calc(100% - var(--footer-pay-height));
                    }

                    &.is-footer {
                        height: calc(100% - var(--footer-height));
                    }

                    &.is-header.is-footer {
                        height: calc(100% - var(--header-height) - var(--footer-height));
                    }

                    &.is-header.is-footer.is-pay {
                        height: calc(100% - var(--header-height) - var(--footer-height) - var(--footer-pay-height));
                    }

                    ::v-deep .el-scrollbar__wrap {
                        margin: 0 !important;
                        scrollbar-width: none;
                        position: relative;

                        &::-webkit-scrollbar {
                            display: none;
                        }
                    }

                    ::v-deep .el-scrollbar__bar {
                        &.is-horizontal,
                        &.is-vertical {
                            opacity: 0;
                        }
                    }
                }

                &_pay-footer {
                    height: var(--footer-pay-height);
                    background-color: #ffffff;
                    box-sizing: border-box;
                    border-top: 1px solid #ebeef5;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-inline: 16px;

                    .pay-money {
                        font-size: 20px;
                        font-weight: 600;
                        color: #f52f51;
                    }

                    .pay-button {
                        color: #ffffff;
                        background-color: #f52f51;
                        padding: 6px 20px;
                        border-radius: 4px;
                        cursor: pointer;
                    }
                }

                &_footer {
                    height: var(--footer-height);
                    background-color: #ffffff;
                    box-sizing: border-box;
                    border-top: 1px solid #ebeef5;

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .menu-item {
                        height: 100%;
                        width: calc(100% / 3);
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-end;
                        align-items: center;
                        // gap: 2px;
                        color: #73727a;

                        .iconfont {
                            font-size: 22px;
                        }

                        span {
                            font-size: 12px;
                        }

                        .iconfont,
                        span {
                            cursor: pointer;
                        }

                        &.is-check {
                            .iconfont,
                            span {
                                color: #f52f51;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
